import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { OOVenueService } from 'src/app/core/services/venue-service';

@Component({
	selector: 'app-employee-scheduling',
	templateUrl: './employee-scheduling.component.html',
	styleUrls: ['../../commandcenter.scss'],
})
export class EmployeeSchedulingComponent implements OnInit, OnDestroy {
	allowedVenueKey: number[] = [15448, 7166, 14683, 17738];
	denyView: boolean = false;
	initialSetup: boolean = false;

	selectedTab: string = 'scheduleList';
	subscription: Subscription = new Subscription();
	tabIndex: number = 0;

	constructor(public app: AppService, public venueService: OOVenueService) {}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	ngOnInit(): void {
		const venueKey = this.venueService.subscriptionVenue.value.key;
		if (!this.allowedVenueKey.includes(venueKey)) {
			this.denyView = true;
		}

		if (!this.denyView) {
			this.subscription.add(
				this.venueService.laborSetup.subscribe((data) => {
					data?.default && this.promptLaborSetupFromDefault();
				})
			);

			if (this.venueService.employeeList.value.length === 0) {
				this.venueService.employeeListGet(this.venueService.subscriptionVenue.value.key);
			}

			if (this.venueService.jobList.value.length === 0) {
				this.venueService.jobListGet(this.venueService.subscriptionVenue.value.key);
			}

			if (this.venueService.laborShiftList.value.length === 0) {
				this.venueService.laborShiftGet(this.venueService.subscriptionVenue.value.key);
			}
			if (!this.venueService.laborSetup.value) {
				this.venueService.laborSetupGet(this.venueService.subscriptionVenue.value.key);
			}
		}
	}

	promptLaborSetupFromDefault() {
		this.initialSetup = true;
		this.app.confirmation.confirm({
			message: `Your Labor & Scheduling Configuration hasn't been setup yet.\nPlease setup your Labor Configuration before proceeding.\nPay close attention to your overtime settings.`,
			rejectVisible: false,
			acceptLabel: 'OK',
			accept: async () => {
				this.selectedTab = 'laborSetup';
				this.app.confirmation.close();
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	tabDisabled(tabIndex: number) {
		if (this.denyView) {
			return true;
		}
		if (this.initialSetup && tabIndex === 2) {
			return false;
		}
		return false;
	}
}
